module.exports = __webpack_public_path__ + "img/discover_world_map.c271ef5.png";